import type { PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";
import { Course } from "types";
import type { RootState } from "../store";

// Define a type for the slice state
interface CoursesState {
  courses: Course[];
}

// Define the initial state using that type
const initialState: CoursesState = {
  courses: [],
};

export const coursesSlice = createSlice({
  name: "courses",
  // `createSlice` will infer the state type from the `initialState` argument
  initialState,
  reducers: {
    // Use the PayloadAction type to declare the contents of `action.payload`
    setGlobalCourses: (state, action: PayloadAction<Course[]>) => {
      state.courses = action.payload;
    },
  },
});

export const { setGlobalCourses } = coursesSlice.actions;

// Other code such as selectors can use the imported `RootState` type
export const getCourses = (state: RootState) => state.courses;
export default coursesSlice.reducer;
